<!--
 * @Author: your name
 * @Date: 2021-10-18 18:10:38
 * @LastEditTime: 2022-05-18 14:25:20
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-business\source\parcel\components\dialogForm.vue
-->
<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :title="$t('SettingOrderSourceStrategyParcel.dialogForm.title')"
    :visible.sync="dialogVisible"
    width="700px"
    :before-close="handleClose"
  >
    <el-form ref="ruleForm" :model="form" :rules="rules" inline class="bj-label-colon">
      <el-form-item :label="form.name">
        <el-row :gutter="20">
          <el-col :span="9">
            <el-form-item prop="typeCondition">
              <el-select v-model="form.typeCondition" :placeholder="$t('chooseText')">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item prop="value">
              <el-input-number
                v-model="form.value"
                :maxlength="MAX_LENGTH.DEFAULT"
                :min="1"
                :precision="0"
                :controls="false"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="status">
              <el-switch
                v-model="form.status"
                :active-value="1"
                :inactive-value="0"
                class="switch"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
    <el-alert
      :title="$t('SettingOrderSourceStrategyParcel.dialogForm.condition')"
      type="warning"
      :closable="false"
      show-icon
    >
    </el-alert>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="confirm">{{ $t('okText') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { orderApi } from '@/api';
export default {
  data() {
    return {
      dialogVisible: false,
      form: {
        id: null,
        // 单个SKU寻源数量
        name: this.$t('SettingOrderSourceStrategyParcel.dialogForm.formName'),
        typeCode: null,
        typeCondition: null,
        value: null,
      },
      rules: {
        typeCondition: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        value: [{ required: true, message: this.$t('SettingOrderSourceStrategyParcel.dialogForm.rulesValue'), trigger: 'blur' }],
      },
      options: [
        {
          value: '&gt;',
          // label: '大于',
          label: '>',
        },
        {
          value: '&gt;=',
          label: '≥',
        },
        {
          value: '&lt;',
          label: '<',
        },
        {
          value: '&lt;=',
          label: '≤',
        },
        {
          value: '==',
          label: '=',
        },
      ],
    };
  },
  created() {},
  methods: {
    reFresh() {
      this.getApi();
    },
    show() {
      this.dialogVisible = true;
      this.reFresh();
    },
    hide() {
      this.dialogVisible = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    confirm() {
      if (this.form.id) {
        this.updateApi(this.form);
      } else {
        this.addApi(this.form);
      }
    },
    updateApi(API_DATA) {
      orderApi.updateSouringStrategyPackageExcludes(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          this.reFresh();
          this.hide();
        }
      });
    },
    addApi(API_DATA) {
      orderApi.addSouringStrategyPackageExcludes(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          this.reFresh();
          this.hide();
        }
      });
    },
    getApi() {
      orderApi.getSouringStrategyPackageExcludes().then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          if (Array.isArray(res.content) && res.content?.length) {
            this.form = { ...res.content[0] };
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
